import '../Vue/Store/global'
import Vue from 'vue'
import ApolloClient from 'apollo-boost'
import VueApollo from 'vue-apollo'
import VueScreen from 'vue-screen'
import { formatMoney } from '@shopify/theme-currency'
import * as images from '@shopify/theme-images'
import '../scripts/lazyloading'
import axios from 'axios'


/* config */
Vue.config.devtools = true
Vue.config.productionTip = false
Vue.config.silent = false

/* extensions */
Vue.prototype.$language = window.theme.strings
Vue.prototype.$image = (src, size = '750x') => images.getSizedImageUrl(src, size)
Vue.prototype.$preloadImages = (imgArray, size = '750x') => images.preload(imgArray, size)
Vue.prototype.$money = amount => formatMoney(amount, '${{amount}}')
Vue.prototype.$isEmpty = obj => {
	if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true
}

/* plugins */
Vue.use(VueApollo)
Vue.use(VueScreen, {
	large_up: 990,
})

const apolloClient = new ApolloClient({
	uri: 'https://moochi-nz.myshopify.com/api/2023-07/graphql.json',
	headers: {
		'Content-Type': 'application/json',
		'X-Shopify-Storefront-Access-Token': '33b31968143b2bfa4e045402f53ba3f7',
	},
})

const apolloProvider = new VueApollo({
	defaultClient: apolloClient,
})

// Global Custom App API
const proxyClient = axios.create({
	headers: {
		'Content-Type': 'application/json',
		'Custom-Token': window?.userInfo.token
	}
})

proxyClient.interceptors.response.use(function(response) {
	if (response.status === 200 && response.data instanceof Blob) return response;
	if (response.data.status !== 0) return Promise.reject(response);
	return response
}, function(error) {
	alert(error)
	return Promise.reject(error)
})

// GraphQL Client
const gqlClient = axios.create({
	baseUrl: `https://${window.location.host}`,
	headers: {
		'X-Shopify-Storefront-Access-Token': '33b31968143b2bfa4e045402f53ba3f7',
		'Content-Type': 'application/json'
	}
})

// Register to Vue
Vue.prototype.$proxy = proxyClient;
Vue.prototype.$gql = gqlClient

/* directives */
Vue.directive('click-outside', {
	bind: function(el, binding, vnode) {
		el.clickOutsideEvent = function(event) {
			// here I check that click was outside the el and his children
			if (!(el == event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event)
			}
		}
		document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind: function(el) {
		document.body.removeEventListener('click', el.clickOutsideEvent)
	},
})

/* components */
/* --------------------------------- Header --------------------------------- */
window.PSVueNav = new Vue({
	name: 'Header',
	comments: true,
	components: {
		'instant-search': require('../Vue/Components/InstantSearch.vue').default,
	},
	data() {
		return {
			isAccountOpen: false,
			isPointsOpen: false,
			availablePoints: 0,
			nextVoucher: '...',
		}
	},
	created() {
		this.$actions.initWishlist();
		this.getUserInfo();
	},
	methods: {
		toggleAccount() {
			this.isAccountOpen = !this.isAccountOpen;

			if (window.matchMedia('(max-width: 767px)').matches) {
				if (this.isAccountOpen) {
					document.querySelector('.main-header').style.backgroundColor = '#fff';
				} else {
					document.querySelector('.main-header').style.backgroundColor = 'transparent';
				}
			}
		},
		togglePoints() {
			this.isPointsOpen = !this.isPointsOpen;
		},
		async getUserInfo() {
			// Get user data (Moochi Money/Gift Cards)
			// If user logged in
			if (userInfo.id) {
				if (window.sessionStorage.getItem('psUserPoints')) {
					let pointsData = JSON.parse(window.sessionStorage.getItem('psUserPoints'));
					this.availablePoints = pointsData.availablePoints;
					this.nextVoucher = pointsData.nextVoucher;
				} else {
					let url = '/a/ps/' + userInfo.id + '/status'

					let options = {
						method: 'GET',
						timeout: 0,
						headers: {
							'custom-token': userInfo.token,
						},
					}

					// Send request
					await fetch(url, options)
						.then(response => response.json())
						.then(data => {
							if (data.message == 'success') {
								if(typeof data.data.loyalty[0] !== 'undefined') {
									this.availablePoints = data.data.loyalty[0].available_points
									this.nextVoucher = Math.ceil(data.data.loyalty[0].spend_for_next_reward)
								} else {
									this.availablePoints = 0;
									this.nextVoucher = 600;
								}
								window.sessionStorage.setItem('psUserPoints', JSON.stringify({
									availablePoints: this.availablePoints,
									nextVoucher: this.nextVoucher
								}))
							}
						})
						.catch(error => {
							console.log('error', error)
						})
				}
			}
		},
	},
}).$mount('.main-header');

/* --------------------------------- Account -------------------------------- */
if (document.querySelector('.account') !== null) {
	window.PSVueAccount = new Vue({
		name: 'Account',
		apolloProvider,
		components: {
			wardrobe: require('../Vue/Components/Wardrobe.vue').default,
			wishlist: require('../Vue/Components/Wishlist.vue').default,
			transition_expand: require('../Vue/Transitions/TransitionExpand.vue').default,
		},
		data() {
			return {
				accountState: '',
				accordionClosed: false,
				activeCTA: 'dashboard',
				newAddressOpen: false,
				editAddressID: 0,
				loading: false,
				availablePoints: '...',
				nextVoucher: '...',
				// Wardrobe Data
				wardrobeLoading: true,
				wardrobeProducts: [],
				wardrobeTotalPage: 1,
				wardrobeCurrentPage: 1,
				wardrobeVariants: [],
				wardrobeIds: [],
			}
		},
		mounted() {
			this.accountState = window.location.pathname
			this.setAccountActive(this.accountState, window.location.search)
			this.fetchWardrobe()
			this.getUserInfo()
		},
		watch: {
			accountState: {
				immediate: true,
				handler() {
					switch (this.activeCTA) {
						case 'addresses':
							setTimeout(() => {
								// Initialize listeners on address selectors, callback in shopify_common.js
								new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
									hideElement: 'AddressProvinceContainerNew',
								})

								// Initialize each edit form's country/province selector
								document.querySelectorAll('.address-country-option').forEach(option => {
									let formId = option.dataset.formId
									let countrySelector = 'AddressCountry_' + formId
									let provinceSelector = 'AddressProvince_' + formId
									let containerSelector = 'AddressProvinceContainer_' + formId
									new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
										hideElement: containerSelector,
									})
								})
							}, 3000)
							break
					}
				},
			},
		},
		methods: {
			setAccountActive(pathname, queryString) {
				if (pathname.includes('/account/addresses')) {
					this.activeCTA = 'addresses'
				} else if (pathname.includes('/account/orders/')) {
					this.activeCTA = 'order'
				}

				if(queryString.includes('wardrobe')) {
					this.activeCTA = 'wardrobe'
				} else if(queryString.includes('all-orders')) {
					this.activeCTA = 'all-orders'
				} else if(queryString.includes('wishlist')) {
					this.activeCTA = 'wishlist'
				}
			},
			updateAccountState(pathname, newActive, async = false) {
				this.loading = true
				this.accordionClosed = this.activeCTA === newActive && this.accordionClosed === false
				this.accountState = pathname
				this.activeCTA = newActive
				let url = window.location.origin + this.accountState
				window.history.replaceState({ path: null }, '', url)
				if (!async) {
					this.loading = false
				}
				if (this.$screen.large_up) {
					this.scrollToTop()
				}
			},
			deleteAddress(formID, confirmMessage) {
				if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
					Shopify.postLink('/account/addresses/' + formID, {
						parameters: {
							_method: 'delete',
						},
					})
				}
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				})
			},
			async getUserInfo() {
				// Get user data (Moochi Money/Gift Cards)
				// If user logged in
				if (userInfo.id) {
					let url = '/a/ps/' + userInfo.id + '/status'

					let options = {
						method: 'GET',
						timeout: 0,
						headers: {
							'custom-token': userInfo.token,
						},
					}

					// Send request
					await fetch(url, options)
						.then(response => response.json())
						.then(data => {
							if (data.message == 'success') {
								if(typeof data.data.loyalty[0] !== 'undefined') {
									this.availablePoints = data.data.loyalty[0].available_points
									this.nextVoucher = Math.ceil(data.data.loyalty[0].spend_for_next_reward)
								} else {
									this.availablePoints = 0;
									this.nextVoucher = 600;
								}
							}
						})
						.catch(error => {
							console.log('error', error)
						})
				}
			},
			welcomeHeading() {
				let startHours = this.$el
						.getAttribute('data-welcome-start')
						.toString()
						.split('|'),
					titles = this.$el.getAttribute('data-welcome-title').split('|'),
					currentHour = new Date().getHours(),
					titleOutput = ''

				if (titles.length) {
					// Use the last hour as the default (late night is also early morning)
					titleOutput = titles[titles.length - 1]

					// Find the title which relates to the current hour
					startHours.forEach(function(startHour, i) {
						let loopHour = parseInt(startHour, 10)

						if (currentHour >= loopHour) {
							titleOutput = titles[i]
						}
					})
				}

				return titleOutput
			},
			// Wardrobe Methods
			fetchWardrobe: function (e) {
				let prefix = `/a/ps/${window?.userInfo.id}/purchase_history?`
				if (e && this.wardrobeCurrentPage < this.wardrobeTotalPage) prefix += `page=${this.wardrobeCurrentPage + 1}`
				this.$proxy.get(prefix).then(({data}) => {
					data = data.data
					this.wardrobeProducts = this.wardrobeProducts.concat(data.data)
					this.wardrobeLoading = false
					this.wardrobeTotalPage = data.last_page
					this.wardrobeCurrentPage = data.current_page
				})
			},
			updateWardrobe: function(e) {
				this.wardrobeVariants = e.items
				this.wardrobeIds = e.ids
			}
		},
	}).$mount('.account')
}

/* ------------------------------- Collection ------------------------------- */
if (document.querySelector('.collection-main') !== null) {
	window.PSVueCollection = new Vue({
		name: 'Collection',
		components: {
			collection: require('../Vue/Components/Collection.vue').default,
		},
	}).$mount('.collection-main')
}

/* ---------------------------- Wishlist Buttons ---------------------------- */
if (document.querySelectorAll('.wishlist-btn-liquid').length) {
	document.querySelectorAll('.wishlist-btn-liquid').forEach(btn => {
		let ID = btn.id
		window.PSTheme.Vue[`WishlistButton${ID}`] = new Vue({
			name: 'WishlistButtonWrapper',
			components: {
				wishlist_button: require('../Vue/Components/WishlistButton.vue').default,
			},
		}).$mount(btn)
	})
}

/* ---------------------------- Homepage Wardrobe ---------------------------- */
if (document.querySelector('.template-index section[data-section-type="welcome"] .wardrobe')) {
	window.PSTheme.Vue['HomepageWardrobe'] = new Vue({
		name: "HomepageWardrobe",
		components: {
			wardrobe: require('../Vue/Components/WardrobeSection').default
		}
	}).$mount(document.querySelector('.template-index section[data-section-type="welcome"] .wardrobe'))
}

/* ---------------------------- Carousel Banner ---------------------------- */
if (document.querySelector('.carousel-banner-section')){
  window.PSTheme.Vue['CarouselBanner'] = new Vue({
    name: 'CarouselBanner',
    components: {
      'carousel-banner': require('../Vue/Components/CarouselBanner').default,
    },
  }).$mount('.carousel-banner-section');
}
